import { Validation } from '../tools';

const defaults = {
  field: {
    isRequired: true,
    validateOnBlur: false,
    // validateOnChange: true,
  },
  fieldText: {
    shouldFitContainer: true,
    value: '',
  },
};

const email = {
  field: {
    ...defaults.field,
    label: 'Fill in the E-mail',
    name: 'email-field',
    validators: [Validation.email],
  },
  fieldText: {
    ...defaults.fieldText,
    name: 'email',
    placeholder: 'email@rbs.report',
    type: 'text',

  },
};

const username = {
  field: {
    ...defaults.field,
    label: 'Fill in the Username',
    name: 'username-field',
    validators: [Validation.username],
  },
  fieldText: {
    ...defaults.fieldText,
    name: 'username',
    placeholder: 'johndoe',
    type: 'text',
  },
};

const password = {
  field: {
    ...defaults.field,
    label: 'Fill in the Password',
    name: 'password-field',
    validators: [Validation.password],
  },
  fieldText: {
    ...defaults.fieldText,
    name: 'password',
    placeholder: '▪▪▪▪▪▪▪▪',
    type: 'password',
  },
};

const serverIP = {
  field: {
    ...defaults.field,
    label: 'Fill in the IP address',
    name: 'server-ip-field',
    validators: [Validation.required],
  },
  fieldText: {
    ...defaults.fieldText,
    name: 'server-ip',
    placeholder: 'Similar to: 123.123.12.123',
    type: 'text',

  },
};

const name = {
  field: {
    ...defaults.field,
    label: 'Fill in the Name',
    name: 'name-field',
    validators: [Validation.string, Validation.minimum()],
  },
  fieldText: {
    ...defaults.fieldText,
    name: 'name',
    placeholder: 'John',
    type: 'text',
  },
};

const surname = {
  field: {
    ...defaults.field,
    label: 'Fill in the Surname',
    name: 'surname-field',
    validators: [Validation.string, Validation.minimum()],
  },
  fieldText: {
    ...defaults.fieldText,
    name: 'surname',
    placeholder: 'Doe',
    type: 'text',
  },
};

export default {
  defaults,
  email,
  name,
  password,
  serverIP,
  surname,
  username,
};
